export default __webpack_public_path__ + "static/media/U_Urubu.89202719.mp3";